<div class="modal-header">
  <h4 class="modal-title">
    {{'iekAssistant.selectCableFedSidePopup.title' | translate}}
  </h4>
</div>
<div class="modal-body pt-0">
  <div class="modal-body-inner">
    <p>{{'iekAssistant.selectCableFedSidePopup.message' | translate}}</p>
    <div class="ps-5">
      <div class="form-check mb-2">
        <input class="form-check-input" type="radio" name="gridRadios" id="cableSideTop" [value]="cableFedSideTop" [(ngModel)]="selectedCableFedSide">
        <label class="form-check-label" for="cableSideTop">{{'iekAssistant.selectCableFedSidePopup.option_top' | translate}}</label>
      </div>

      <div class="form-check mb-2">
        <input class="form-check-input" type="radio" name="gridRadios" id="cableSideBottom" [value]="cableFedSideBottom" [(ngModel)]="selectedCableFedSide">
        <label class="form-check-label" for="cableSideBottom">{{'iekAssistant.selectCableFedSidePopup.option_bottom' | translate}}</label>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary btn-forward" (click)="close()">{{'global.label.ok' | translate}}</button>
</div>
